import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Back = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="back icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2426 6.41421C14.0237 5.63317 14.0237 4.36684 13.2426 3.58579C12.4616 2.80474 11.1953 2.80474 10.4142 3.58579L2 12L10.4142 20.4142C11.1953 21.1953 12.4616 21.1953 13.2426 20.4142C14.0237 19.6332 14.0237 18.3668 13.2426 17.5858L9.65685 14L20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10L9.65685 10L13.2426 6.41421Z"
    />
  </svg>
)
